import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Box
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { download_corrections_report, download_pp_report } from '../../store/job/jobSlice';

const DownloadReportModal = ({ open, handleClose, reportType }) => {
    const dispatch = useDispatch();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [groupBy, setGroupBy] = useState('month');

    // Reset fields when the modal opens or after downloading
    React.useEffect(() => {
        if (open) {
            setFromDate('');
            setToDate('');
            setGroupBy('month');
        }
    }, [open]);

    const handleDownload = () => {
        if (reportType === 'correction') {
            dispatch(download_corrections_report({ from_date: fromDate, to_date: toDate, group_by: groupBy }))
                .then((res) => {
                    if (res.meta.requestStatus === 'fulfilled') {
                        const blob = new Blob([res.payload.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.href = url;
                        a.download = `Corrections_Report_${fromDate}_to_${toDate}.xlsx`;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();

                        handleClose();
                    } else {
                        console.error("Download failed", res);
                    }
                });
        } else if (reportType === 'completion') {
            dispatch(download_pp_report({ from_date: fromDate, to_date: toDate }))
                .then((res) => {
                    if (res.meta.requestStatus === 'fulfilled') {
                        const blob = new Blob([res.payload.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.href = url;
                        a.download = `Completed_Jobs_Report_${fromDate}_to_${toDate}.xlsx`;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();

                        handleClose();
                    } else {
                        console.error("Download failed", res);
                    }
                });
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                {reportType === 'correction' ? 'Download Correction Report' : 'Download Completion Report'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
                    <TextField
                        label="From Date"
                        type="date"
                        value={fromDate}
                        onChange={(e) => {
                            setFromDate(e.target.value);
                            // If to date is now before new from date, clear it
                            if (toDate && e.target.value && toDate < e.target.value) {
                                setToDate('');
                            }
                        }}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        size="small"
                    />
                    <TextField
                        label="To Date"
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        inputProps={{ min: fromDate || undefined }}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        size="small"
                        error={!!(fromDate && toDate && toDate < fromDate)}
                        helperText={fromDate && toDate && toDate < fromDate ? 'To Date cannot be before From Date' : ''}
                    />
                    {reportType === 'correction' && (
                        <FormControl fullWidth size="small">
                            <InputLabel>Group By</InputLabel>
                            <Select
                                value={groupBy}
                                label="Group By"
                                onChange={(e) => setGroupBy(e.target.value)}
                            >
                                <MenuItem value="month">Month</MenuItem>
                                <MenuItem value="day">Day</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={handleClose} variant="outlined" color="primary">Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleDownload}
                    disabled={!fromDate || !toDate || toDate < fromDate}
                    color="primary"
                >
                    Download
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DownloadReportModal;
